import React, { memo } from 'react';
import { useModalNotifications } from '../hooks/useNotifications';
import NotificationListPremium from './NotificationListPremium';

const NotificationTable = memo(({ notifications = [], showActions = true, onNavigateAway }) => {
  const { markAsRead, isMarkingAsRead } = useModalNotifications();

  if (!showActions) {
    return (
      <NotificationListPremium
        notifications={notifications}
        onMarkAsRead={() => {}}
        isMarkingAsRead={false}
        onNavigateAway={onNavigateAway}
      />
    );
  }

  return (
    <NotificationListPremium
      notifications={notifications}
      onMarkAsRead={markAsRead}
      isMarkingAsRead={isMarkingAsRead}
      onNavigateAway={onNavigateAway}
    />
  );
});

NotificationTable.displayName = 'NotificationTable';

export default NotificationTable;
